import React from 'react';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <p className="footer__copyright">&copy; 2026 Система контроля климата</p>
      </div>
    </footer>
  );
};

export default Footer;